import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _get from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/get.js";
import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/regenerator/index.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from "react";
import { tsParticles } from "tsparticles-engine";
import equal from "deep-eql";
var defaultId = "tsparticles";

var Particles = /*#__PURE__*/function (_Component) {
  _inherits(Particles, _Component);

  var _super = _createSuper(Particles);

  function Particles(props) {
    var _this;

    _classCallCheck(this, Particles);

    _this = _super.call(this, props);
    _this.state = {
      init: false,
      library: undefined
    };
    return _this;
  }

  _createClass(Particles, [{
    key: "destroy",
    value: function destroy() {
      if (!this.state.library) {
        return;
      }

      this.state.library.destroy();
      this.setState({
        library: undefined
      });
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return !equal(nextProps, this.props);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.refresh();
    }
  }, {
    key: "forceUpdate",
    value: function forceUpdate() {
      var _this2 = this;

      this.refresh().then(function () {
        _get(_getPrototypeOf(Particles.prototype), "forceUpdate", _this2).call(_this2);
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this3 = this;

      _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!_this3.props.init) {
                  _context2.next = 3;
                  break;
                }

                _context2.next = 3;
                return _this3.props.init(tsParticles);

              case 3:
                _this3.setState({
                  init: true
                }, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return _this3.loadParticles();

                        case 2:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                })));

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.destroy();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          width = _this$props.width,
          height = _this$props.height,
          className = _this$props.className,
          canvasClassName = _this$props.canvasClassName,
          id = _this$props.id;
      return React.createElement("div", {
        className: className,
        id: id
      }, React.createElement("canvas", {
        className: canvasClassName,
        style: _objectSpread(_objectSpread({}, this.props.style), {}, {
          width: width,
          height: height
        })
      }));
    }
  }, {
    key: "refresh",
    value: function () {
      var _refresh = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.destroy();
                _context3.next = 3;
                return this.loadParticles();

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function refresh() {
        return _refresh.apply(this, arguments);
      }

      return refresh;
    }()
  }, {
    key: "loadParticles",
    value: function () {
      var _loadParticles = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var _this4 = this,
            _ref4,
            _this$props$id,
            _this$props$params;

        var cb, id, container;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (this.state.init) {
                  _context5.next = 2;
                  break;
                }

                return _context5.abrupt("return");

              case 2:
                cb = /*#__PURE__*/function () {
                  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(container) {
                    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                      while (1) {
                        switch (_context4.prev = _context4.next) {
                          case 0:
                            if (_this4.props.container) {
                              _this4.props.container.current = container;
                            }

                            _this4.setState({
                              library: container
                            });

                            if (!_this4.props.loaded) {
                              _context4.next = 5;
                              break;
                            }

                            _context4.next = 5;
                            return _this4.props.loaded(container);

                          case 5:
                          case "end":
                            return _context4.stop();
                        }
                      }
                    }, _callee4);
                  }));

                  return function cb(_x) {
                    return _ref3.apply(this, arguments);
                  };
                }();

                id = (_ref4 = (_this$props$id = this.props.id) !== null && _this$props$id !== void 0 ? _this$props$id : Particles.defaultProps.id) !== null && _ref4 !== void 0 ? _ref4 : defaultId;

                if (!this.props.url) {
                  _context5.next = 10;
                  break;
                }

                _context5.next = 7;
                return tsParticles.loadJSON(id, this.props.url);

              case 7:
                _context5.t0 = _context5.sent;
                _context5.next = 13;
                break;

              case 10:
                _context5.next = 12;
                return tsParticles.load(id, (_this$props$params = this.props.params) !== null && _this$props$params !== void 0 ? _this$props$params : this.props.options);

              case 12:
                _context5.t0 = _context5.sent;

              case 13:
                container = _context5.t0;
                _context5.next = 16;
                return cb(container);

              case 16:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function loadParticles() {
        return _loadParticles.apply(this, arguments);
      }

      return loadParticles;
    }()
  }]);

  return Particles;
}(Component);

Particles.defaultProps = {
  width: "100%",
  height: "100%",
  options: {},
  style: {},
  url: undefined,
  id: defaultId
};
export default Particles;